export const DEFAULT_IS_MULTIPLE_POV_STATE = { value: false, userChanged: false };

const cloneState = (state) => ({ value: !!state.value, userChanged: !!state.userChanged });

export function normalizeIsMultiplePOVState(input, fallback = DEFAULT_IS_MULTIPLE_POV_STATE) {
  const base = fallback && typeof fallback === "object" ? cloneState(fallback) : cloneState(DEFAULT_IS_MULTIPLE_POV_STATE);

  if (input === null || typeof input === "undefined") {
    return base;
  }

  if (typeof input === "boolean") {
    return { value: input, userChanged: base.userChanged };
  }

  if (typeof input === "object") {
    const { value, userChanged } = input;
    return {
      value: typeof value === "boolean" ? value : base.value,
      userChanged: typeof userChanged === "boolean" ? userChanged : base.userChanged,
    };
  }

  return base;
}

export function getDefaultIsMultiplePOVState() {
  return cloneState(DEFAULT_IS_MULTIPLE_POV_STATE);
}
